<template>
  <div>
    <b-modal
      id="modal-updateprod"
      hide-footer
      centered
      title=" "
      ref="currMeUpdate"
      style="position: relative"
    >
      <GStockLoader :loading="loading" />
      <form @submit.prevent>
        <h6 class="heading-small text-muted mb-4">Mettre à jour un Article</h6>

        <div class="pl-lg-4">
          <div class="row">
            <div class="col-lg-6">
              <base-input
                alternative
                label="Nom de l'article"
                placeholder="Nom de l'article"
                input-classes="form-control-alternative"
                v-model="product.name"
              />
            </div>
            <div class="col-lg-6">
              <base-input
                alternative
                label="Prix"
                placeholder="Prix"
                input-classes="form-control-alternative"
                v-model="price"
              />
            </div>
            <div class="col-lg-6">
              <base-input
                alternative
                label="Pourcentage en %"
                placeholder="Pourcentage en %"
                input-classes="form-control-alternative"
                v-model="percentage"
              />
            </div>
            <div
              class="col-lg-6"
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
              "
            >
              {{ "En main : " + originalPrice + " DT" }}
            </div>
            <div class="col-lg-12">
              Crédit
              <b-dropdown
                id="dropdown-1"
                :text="credit ? 'Oui' : 'Non'"
                class="m-md-2"
              >
                <b-dropdown-item @click="credit = 1">Oui</b-dropdown-item>
                <b-dropdown-item @click="credit = 0">Non</b-dropdown-item>
              </b-dropdown>
            </div>
            <!-- <div class="col-lg-12">
              <b-form-input
                v-model="search"
                size="sm"
                class="mr-sm-2"
                placeholder="Chercher client par nom"
              ></b-form-input>
            </div> -->
            <div class="col-lg-12">
              <b-form-group
                id="input-group-5"
                label="Déposant"
                label-for="input-5"
              >
                <b-form-input
                  list="collection-id"
                  v-model="product.owner"
                ></b-form-input>

                <datalist id="collection-id">
                  <option
                    v-for="client in clients"
                    :value="client.value"
                    :key="client.value"
                  >
                    {{ client.text }}
                  </option>
                </datalist>
              </b-form-group>
            </div>
          </div>
        </div>

        <hr class="my-4" />
        <!-- Description -->
        <center>
          <b-btn
            type="submit"
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            @click="postProduct($event)"
            >Mettre à jour</b-btn
          >
        </center>
      </form>
    </b-modal>
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import { get, put, postFile } from "@/mixins/api";
export default {
  name: "ModalUpdateProduit",
  components: {
    GStockLoader,
  },
  props: {
    prod: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      search: "",
      imagesToUpload: [],
      images: [],
      name: "",

      model: {
        categorie: null,

        titre: "",
        description: "",
        prix: "",
      },
      clients: [],
      product: {
        name: "",
        price: 0.0,
        credit: 0,
        percentage: 0.3,
        owner: null,
      },
      price: 0.0,
      credit: 0,
      originalPrice: 0.0,
      percentage: 30,
      loading: false,
    };
  },
  watch: {
    price: {
      handler: function (newVal) {
        this.calculatePrice();
      },
    },
    percentage: {
      handler: function (newVal) {
        this.calculatePrice();
      },
    },
  },
  methods: {
    calculatePrice() {
      try {
        if (
          isNaN(this.price) ||
          isNaN(this.percentage) ||
          this.price == "" ||
          this.percentage == ""
        )
          throw "";
        const price = parseFloat(this.price);
        const val = this.percentage;
        const percentage = parseFloat(val);
        this.originalPrice = (price * (1 - percentage / 100)).toFixed(2);
      } catch (exception) {
        this.originalPrice = 0.0;
      }
    },
    handleSelects(e) {
      this.images = [];
      this.imagesToUpload = e.target.files;
      console.log(this.imagesToUpload);
      let fileList = Array.prototype.slice.call(e.target.files);
      fileList.forEach((f) => {
        if (!f.type.match("image.*")) {
          return;
        }

        let reader = new FileReader();
        let that = this;

        reader.onload = function (e) {
          that.images.push(e.target.result);
        };
        reader.readAsDataURL(f);
      });
    },
    getClients() {
      get("clients").then((response) => {
        this.clients = response.data.data.map((it) => {
          return { text: it.fullname, value: it.id };
        });
      });
    },
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Ajout produit.",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
    postProduct(e) {
      e.stopPropagation();
      try {
        const stop =
          isNaN(this.originalPrice) ||
          isNaN(this.percentage) ||
          this.originalPrice == "" ||
          this.percentage == "";
        const price = parseFloat(this.price);
        const val = this.percentage;
        const percentage = parseFloat(val) / 100;
        if (
          this.product.owner != null &&
          price != 0 &&
          percentage != 0 &&
          this.product.name != "" &&
          !stop
        ) {
          this.product.price = price;
          this.product.credit = this.credit;
          this.product.percentage = percentage;
          this.loading = true;
          put("product/" + this.product.id, this.product)
            .then((res) => {
              this.$emit("added");
              this.$refs.currMeUpdate.hide();
            })
            .catch((err) => {
              this.makeToast("Une erreur est survenue merci de résseayez.");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          throw "Invalid product";
        }
      } catch (e) {
        this.makeToast("Vérifiez les données que vous avez saisit.");
      }
    },
    showMe(prod) {
      this.product = {
        id: prod.id,
        name: prod.name,
        price: prod.price + "",
        percentage: prod.percentage + "",
        owner: prod.owner,
      };
      this.price = prod.price;
      this.credit = prod.credit;
      this.percentage = prod.percentage * 100;
      this.$refs.currMeUpdate.show();
    },
  },
  mounted() {
    this.getClients();
  },
};
</script>

<style lang="scss" scoped>
img {
  float: left;
  border-style: none;
  width: 100px;
  height: 80px;
}
</style>
